import React from 'react'
import {
  collection,
  doc,
  getCountFromServer,
  getDoc,
  query,
  where,
} from 'firebase/firestore'

import { Icon } from '@components/icon.component'
import { getUserFullName } from '@utils/helpers'
import { useLoad } from '@hooks/use-load.hook'
import { db } from '@src/firebase-app'
import { dbNames } from '@utils/constants'
import { Pill } from '@components/pill/pill.component'
import { WorkflowProgressBar } from '@components/workflow-progress-bar.component'
import { Loader } from '@components/loader.component'
import { isEmpty } from 'lodash'

type MentoringInviteBodyProps = {
  inviteUser: any
  org: any
  activityId: string
}

export function MentoringInviteBody({ inviteUser, org, activityId }: MentoringInviteBodyProps) {
  const [activity] = useLoad(
    {} as any,
    () => {
      const d = doc(db, dbNames.activities, activityId)
      return getDoc(d).then(snap => ({ id: snap.id, ...snap.data() }))
    },
    [activityId],
  )

  const [activityUser] = useLoad(
    {},
    () => {
      const d = doc(db, dbNames.activityUsers, `${activityId}_${inviteUser.id}`)
      return getDoc(d).then(snap => ({ id: snap.id, ...snap.data() }))
    },
    [activityId, inviteUser.id],
  )

  const [sectionsCount] = useLoad(
    null,
    () => {
      const q = query(
        collection(db, dbNames.activitySections),
        where('activityId', '==', activityId),
      )
      return getCountFromServer(q).then(snap => snap.data().count)
    },
    [activityId],
  )

  const orgName = org.id === inviteUser.id ? '' : org.name

  return (
    <div
      className="invitation-details__body"
    >
      <div className="user__title">
        <div className="user-avatar">
          <Icon
            name="user"
            size={10}
          />
        </div>{' '}
        {getUserFullName(inviteUser)}
      </div>
      <div className="mt-5">Has invited you to mentor their workflow</div>
      <div className="description__container">
        {isEmpty(activity) ? (
          <Loader />
        ) : (
          <>
            <div className="mb-3 flex w-full items-center justify-between">
              <div className="flex items-center">
                <div>
                  <div className="user-avatar">
                    <Icon
                      name="user"
                      size={10}
                    />
                  </div>
                </div>
                <div>
                  <div className="text-[1.6rem] font-medium">{activity.name}</div>
                  <div>
                    {getUserFullName(inviteUser)} {orgName}
                  </div>
                </div>
              </div>
              <div>
                <Pill>
                  {sectionsCount} section{sectionsCount === 1 ? '' : 's'}
                </Pill>
              </div>
            </div>
            <div className="w-full">
              <WorkflowProgressBar
                activity={activity}
                activityUser={activityUser}
              />
            </div>
          </>
        )}
      </div>
    </div>
  )
}
